import { ConnectionStatus, GoogleAuthResponse } from '../types/connections';
import { apiFetch } from './api';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export const connectionService = {
  async getStatus(): Promise<ConnectionStatus> {
    const response = await apiFetch(`${API_URL}/connections/status`, {
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to fetch connection status');
    return response.json();
  },

  async connectGBQ(authResponse: GoogleAuthResponse, projectId: string): Promise<void> {
    const response = await apiFetch(`${API_URL}/connections/gbq`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        accessToken: authResponse.access_token,
        refreshToken: authResponse.refresh_token || null,
        projectId
      })
    });
    if (!response.ok) throw new Error('Failed to connect GBQ');
  },

  async connectGA4(authResponse: GoogleAuthResponse, propertyId: string): Promise<void> {
    const response = await apiFetch(`${API_URL}/connections/ga4`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        accessToken: authResponse.access_token,
        refreshToken: authResponse.refresh_token || null,
        propertyId
      })
    });
    if (!response.ok) throw new Error('Failed to connect GA4');
  },

  async disconnect(type: 'gbq' | 'ga4' | 'gads', id: string): Promise<void> {
    console.log(`Making DELETE request to: ${API_URL}/connections/${type}/${id}`);
    const response = await apiFetch(`${API_URL}/connections/${type}/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    console.log(`Response status: ${response.status}`);
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`Error response: ${errorText}`);
      throw new Error(`Failed to disconnect ${type}: ${response.status} ${errorText}`);
    }
  }
}; 